import { CART_MODULE } from "@/api_framework/api_config";
import { ICartLevelCouponListResponse, ICartLevelCouponListResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setCartLevelCoupon } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const useCartLevelCouponListAPI = () => {
  const configuration = useConfiguration();
  const [data, setData] = useState<ICartLevelCouponListResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const clearSearchResults = () => {
    setData([]);
  };

  const execute = useCallback(
    async (cartId: string, clinicId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${CART_MODULE?.CART_LEVEL_COUPON?.baseURL}`, {
            params: {
              cart_id: cartId,
              clinic_id: clinicId,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartLevelCouponListResponse>) => {
            if (res.data.status === true) {
              setData(res.data.data);
              dispatch(setCartLevelCoupon(res.data.data));
              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              dispatch(setCartLevelCoupon([]));
              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(setCartLevelCoupon([]));
            captureError(e);
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        dispatch(setCartLevelCoupon([]));
        captureError(e);
      }
    },
    [dispatch],
  );
  return { data, execute, clearSearchResults };
};
